import { exhaustive } from "exhaustive";
import { apiGet, apiPost, NoDataResponse } from "fetchApi";

export const sendTaskAction = async (taskNumber: number, message: string): Promise<NoDataResponse> => {
    const data = {
        task_number: taskNumber,
        message: message,
    };
    return apiPost<object>("/vk_data/tasks/actions/", data);
};

export interface ITaskResult {
    status: string;
}

export const checkTaskStatus = async (uuid: string): Promise<ITaskResult> => {
    const returnData = await apiGet<ITaskResult>(`/configurations/task-results/${uuid}`);
    return exhaustive(returnData, "responseType", {
        Success: (it) => {
            return it.data;
        },
        Error: () => {
            return {} as ITaskResult;
        },
    });
};
